import React, { useState } from 'react';
import { Lightbulb, ChevronDown, ChevronUp } from 'lucide-react';

interface QuickSummaryProps {
    points: string[];
    title?: string;
}

const QuickSummary: React.FC<QuickSummaryProps> = ({
    points,
    title = "Resumo Rápido (TL;DR)"
}) => {
    const [isExpanded, setIsExpanded] = useState(true);

    if (!points || points.length === 0) return null;

    return (
        <div className="my-8 bg-gradient-to-br from-amber-50 to-yellow-50 rounded-2xl border border-amber-200 overflow-hidden shadow-sm">
            <button
                onClick={() => setIsExpanded(!isExpanded)}
                className="w-full px-6 py-4 flex items-center justify-between bg-gradient-to-r from-amber-100 to-yellow-100 hover:from-amber-200 hover:to-yellow-200 transition-colors"
            >
                <div className="flex items-center gap-3">
                    <div className="p-2 bg-amber-500 rounded-lg">
                        <Lightbulb className="w-5 h-5 text-white" />
                    </div>
                    <h3 className="text-lg font-bold text-amber-900">{title}</h3>
                </div>
                {isExpanded ? (
                    <ChevronUp className="w-5 h-5 text-amber-700" />
                ) : (
                    <ChevronDown className="w-5 h-5 text-amber-700" />
                )}
            </button>

            {isExpanded && (
                <div className="px-6 py-4">
                    <ul className="space-y-3">
                        {points.map((point, index) => (
                            <li
                                key={index}
                                className="flex items-start gap-3 text-amber-900"
                            >
                                <span className="flex-shrink-0 w-6 h-6 bg-amber-500 text-white rounded-full flex items-center justify-center text-sm font-bold mt-0.5">
                                    {index + 1}
                                </span>
                                <span className="leading-relaxed">{point}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default QuickSummary;
